import { z } from 'zod';
import { CompanyType, FormCompanyType } from '@repo/shared/types';

import { companySchema } from './company.schema';
import { jdgCompanySchema } from './jdg-company.schema';
import type { loanFormAgreementsSchema } from './loan-form-agreements.schema';

export const loanFormSchema = companySchema.extend(jdgCompanySchema.shape);

type Modify<T, R> = Omit<T, keyof R> & R;

export type LoanFormInputFields = Modify<
  z.infer<typeof loanFormSchema>,
  z.infer<typeof loanFormAgreementsSchema>
>;

export type FormSchemaByCompanyType<T extends FormCompanyType> = T extends 'jednoosobowa'
  ? z.infer<typeof jdgCompanySchema>
  : z.infer<typeof companySchema>;

export const schemaByCompanyType: {
  jednoosobowa: typeof jdgCompanySchema;
  other: typeof companySchema;
} = {
  jednoosobowa: jdgCompanySchema,
  other: companySchema,
};

export const companyType = (type: CompanyType): FormCompanyType =>
  type === 'jednoosobowa' ? 'jednoosobowa' : 'other';
